export function getInputRangeFromIndexes (range, index, carouselProps) {
    const sizeRef = carouselProps.vertical ? carouselProps.itemHeight : carouselProps.itemWidth
    const inputRange = []

    for (let i = 0; i < range.length; i++) {
        inputRange.push((index - range[i]) * sizeRef)
    }

    return inputRange
}

export function stackScrollInterpolator (index, carouselProps) {
    const range = [3, 2, 1, 0, -1]
    const inputRange = getInputRangeFromIndexes(range, index, carouselProps)
    const outputRange = range

    return { inputRange, outputRange }
}
export function stackAnimatedStyles (index, animatedValue, carouselProps, cardOffset) {
    const sizeRef = carouselProps.vertical ? carouselProps.itemHeight : carouselProps.itemWidth
    const translateProp = carouselProps.vertical ? 'translateY' : 'translateX'

    const card1Scale = 0.9
    const card2Scale = 0.8

    cardOffset = !cardOffset && cardOffset !== 0 ? 9 : cardOffset

    const getTranslateFromScale = (cardIndex, scale) => {
        const centerFactor = 1 / scale * cardIndex
        const centeredPosition = -Math.round(sizeRef * centerFactor)
        const edgeAlignment = Math.round((sizeRef - (sizeRef * scale)) / 2)
        const offset = Math.round(cardOffset * Math.abs(cardIndex) / scale)

        return centeredPosition + edgeAlignment + offset
    }

    const opacityOutputRange = carouselProps.inactiveSlideOpacity === 1 ? [1, 1, 1, 0] : [1, 0.75, 0.5, 0]

    return {
        elevation: carouselProps.data.length - index,
        zIndex: carouselProps.data.length - index,
        opacity: animatedValue.interpolate({
            inputRange: [0, 1, 2, 3],
            outputRange: opacityOutputRange,
            extrapolate: 'clamp',
        }),
        transform: [{
            scale: animatedValue.interpolate({
                inputRange: [-1, 0, 1, 2],
                outputRange: [card1Scale, 1, card1Scale, card2Scale],
                extrapolate: 'clamp',
            }),
        }, {
            [translateProp]: animatedValue.interpolate({
                inputRange: [-1, 0, 1, 2, 3],
                outputRange: [
                    -sizeRef * 0.5,
                    0,
                    getTranslateFromScale(1, card1Scale),
                    getTranslateFromScale(2, card2Scale),
                    getTranslateFromScale(3, card2Scale),
                ],
                extrapolate: 'clamp',
            }),
        }],
    }
}
